import { useQuery } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';
import type { PromotionFilters } from '../types/promotions.types';

export function usePromotions(filters?: PromotionFilters) {
  return useQuery({
    queryKey: ['promotions', filters],
    queryFn: () => promotionsService.getPromotions(filters),
  });
}
